/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModSurveys: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M15.9189 0.0594631C15.8479 -0.00253688 15.7459 -0.0175369 15.6599 0.0224631L0.138907 7.21446C0.0549074 7.25346 0.000907358 7.33646 -9.26421e-05 7.42846C-0.00109264 7.52046 0.0509074 7.60546 0.133907 7.64546L4.52591 9.79546C4.60691 9.83446 4.70291 9.82646 4.77491 9.77246L9.04591 6.58846L5.69291 10.0285C5.64591 10.0785 5.62091 10.1445 5.62591 10.2125L5.95991 14.5485C5.96691 14.6455 6.03191 14.7275 6.12391 14.7575C6.14791 14.7655 6.17391 14.7695 6.19791 14.7695C6.26691 14.7695 6.33291 14.7405 6.37891 14.6865L8.71091 11.9925L11.5929 13.3655C11.6549 13.3955 11.7279 13.3965 11.7919 13.3695C11.8559 13.3415 11.9029 13.2885 11.9239 13.2215L15.9889 0.310463C16.0179 0.219463 15.9889 0.121463 15.9189 0.0594631Z'
			/>
		</Svg>
	);
};

export { ModSurveys };
